<template>
  <div>
    <template v-for="point in pointList">
      <CampaignModalPageGeoMapMarker
        :key="point.id"
        :point="point"
        :is-active="isActive(point)"
      />
    </template>
  </div>
</template>

<script>
import CampaignModalPageGeoMapMarker from './CampaignModalPageGeoMapMarker.vue'
export default {
  name: 'CampaignModalPageGeoMapMarkerContainer',
  components: { CampaignModalPageGeoMapMarker },
  props: {
    pointList: {
      type: Array,
      default: () => [],
    },
    selectedLocationGroups: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    selectedLocationGroupIds() {
      return this.selectedLocationGroups.map(g => g.locationGroupId)
    },
  },
  methods: {
    isActive(point) {
      return (
        this.selectedLocationGroupIds.findIndex(
          id => point.locationGroupId === id,
        ) !== -1
      )
    },
  },
}
</script>

<style></style>
